const constants = require('@/util/constants')
require('./config')

/**
 * 获取当前会话
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getThreads (successcb, failedcb) {
  axios.get('/api/thread/get', {
    params: {
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 获取机器人会话
 * 
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getRobotThreads(page, size, closed, successcb, failedcb) {
  axios.get('/api/thread/get/robot', {
    params: {
      'page': page,
      'size': size,
      'closed': closed,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}


/**
 * 管理员获取全部用户历史会话
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function queryThread (page, size, successcb, failedcb) {
  axios.get('/api/thread/query', {
    params: {
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 客服获取某访客历史会话
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getHistoryThreads (page, size, uid, successcb, failedcb) {
  axios.get('/api/thread/history', {
    params: {
      'page': page,
      'size': size,
      'uid': uid,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 客服端分页加载-客服自己的历史会话：客服会话
 * @param {*} page page
 * @param {*} size size
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getThreadHistoryRecords (page, size, successcb, failedcb) {
  axios.get('/api/thread/history/records', {
    params: {
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 搜索过滤历史会话
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function filterHistoryThread (page, size, nickname, createdAtStart, createdAtEnd,
  workGroupNickname, agentRealName, client, successcb, failedcb) {
  axios.get('/api/thread/filter', {
    params: {
      'page': page,
      'size': size,
      'nickname': nickname,
      'createdAtStart': createdAtStart,
      'createdAtEnd': createdAtEnd,
      'workGroupNickname': workGroupNickname,
      'agentRealName': agentRealName,
      'client': client
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 搜索过滤历史会话
 * 
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function searchHistoryThread(content, page, size, successcb, failedcb) {
  axios.get('/api/thread/search', {
    params: {
      'content': content,
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 获取联系人会话
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getContactThread (cid, successcb, failedcb) {
  axios.get('/api/thread/contact', {
    params: {
      'cid': cid,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 获取群组会话
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getGroupThread (gid, successcb, failedcb) {
  axios.get('/api/thread/group', {
    params: {
      'gid': gid,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 获取频道会话
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getChannelThread(successcb, failedcb) {
  axios.get('/api/thread/channel', {
    params: {
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 获取工单会话
 * 
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getTicketThread(successcb, failedcb) {
  axios.get('/api/thread/ticket', {
    params: {
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 标记删除会话
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function markThreadDeleted (tid, successcb, failedcb) {
  axios.post('/api/thread/mark/deleted', {
    tid,
    'client': constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 取消标记删除会话
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function unmarkThreadDeleted (tid, successcb, failedcb) {
  axios.post('/api/thread/unmark/deleted', {
    tid,
    'client': constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 更新当前会话thread
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function updateCurrentThread (preTid, tid, successcb, failedcb) {
  axios.post('/api/thread/update/current', {
    preTid,
    tid,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 重新开始会话
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function restartThread(tid, topic, successcb, failedcb) {
  axios.post('/api/thread/restart', {
    tid,
    topic,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 客服关闭会话
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function agentCloseThread (tid, successcb, failedcb) {
  axios.post('/api/thread/agent/close', {
    tid: tid,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 获取监控会话
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getMonitorThreads (successcb, failedcb) {
  axios.get('/api/thread/monitor', {
    params: {
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 获取质量检查会话
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getQualityThreads (page, size, successcb, failedcb) {
  axios.get('/api/thread/quality', {
    params: {
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 拉取置顶会话
 * 
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getTopThreads(page, size, successcb, failedcb) {
  axios.get('/api/v2/thread/mark/top', {
    params: {
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}


/**
 * 会话置顶
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function markTop(tid, successcb, failedcb) {
  axios.post('/api/v2/thread/mark/top', {
    tid,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 取消会话置顶
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function unmarkTop(tid, successcb, failedcb) {
  axios.post('/api/v2/thread/unmark/top', {
    tid,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

// /**
//  * 会话免打扰
//  * @param {*} successcb 成功回调
//  * @param {*} failedcb 失败回调
//  */
// export function markNodisturb(tid, successcb, failedcb) {
//   axios.post('/api/thread/mark/nodisturb', {
//     tid,
//     client: constants.HTTP_CLIENT
//   }).then(response => {
//     successcb(response.data)
//   }).catch(error => {
//     failedcb(error)
//   })
// }

/**
 * 会话免打扰
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function markNodisturb(uid, tid, successcb, failedcb) {
  axios.post('/api/v2/thread/mark/nodisturb', {
    uid,
    tid,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

// /**
//  * 取消会话免打扰
//  * @param {*} successcb 成功回调
//  * @param {*} failedcb 失败回调
//  */
// export function unmarkNodisturb(tid, successcb, failedcb) {
//   axios.post('/api/thread/unmark/nodisturb', {
//     tid,
//     client: constants.HTTP_CLIENT
//   }).then(response => {
//     successcb(response.data)
//   }).catch(error => {
//     failedcb(error)
//   })
// }

/**
 * 取消会话免打扰
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function unmarkNodisturb(uid, tid, successcb, failedcb) {
  axios.post('/api/v2/thread/unmark/nodisturb', {
    uid,
    tid,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 会话未读
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function markUnread(tid, successcb, failedcb) {
  axios.post('/api/v2/thread/mark/unread', {
    tid,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 取消会话未读
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function unmarkUnread(tid, successcb, failedcb) {
  axios.post('/api/v2/thread/unmark/unread', {
    tid,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 星标会话
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function markStar(tid, starType, successcb, failedcb) {
  axios.post('/api/v2/thread/mark/star', {
    tid,
    starType,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 拉取星标会话
 * 
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getStarThreads(page, size, successcb, failedcb) {
  axios.get('/api/v2/thread/mark/star', {
    params: {
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}


/**
 * 获取会话URL
 * 
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getThreadUrl(tid, successcb, failedcb) {
  axios.get('/api/thread/get/url', {
    params: {
      'tid': tid,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}
